import React from "react";
import { MessageCircle } from "lucide-react";
import { trackEvent } from "../lib/analytics";

export const FloatingWhatsApp = () => {
  return (
    <a
      href="https://wa.me/971502856909"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      onClick={() => trackEvent("whatsapp_click", { source: "floating_button" })}
      className="fixed bottom-16 right-6 z-50 flex items-center gap-2 bg-[#25D366] hover:bg-[#1da851] text-white rounded-full pl-4 pr-5 py-3 shadow-lg shadow-[#25D366]/30 hover:shadow-xl hover:shadow-[#25D366]/40 hover:-translate-y-0.5 group"
      style={{ transition: "background-color 0.3s, box-shadow 0.3s, transform 0.3s" }}
    >
      <MessageCircle size={22} className="flex-shrink-0" />
      <span className="text-sm font-semibold hidden sm:inline">Chat with us</span>
    </a>
  );
};
